import { fetchApi } from '../utils/helpers';
import constants from '../constants';

const {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} = constants;

/**
 * Fetch users
 */
export const fetchUsersSuccess = data => ({
  type: FETCH_USERS_SUCCESS,
  payload: {
    users: data.users,
  },
});

export const fetchUsersFailure = () => ({
  type: FETCH_USERS_FAILURE,
});

export const fetchUsersRequest = () => ({
  type: FETCH_USERS_REQUEST,
});

export const fetchUsers = token => dispatch => {
  dispatch(fetchUsersRequest());

  return fetchApi({
    path: '/users',
    method: 'get',
    token,
    dispatch,
    cb: fetchUsersSuccess,
    fb: fetchUsersFailure,
  });
};

/**
 * Create user
 */
export const createUserSuccess = (resolve, data) => dispatch => {
  resolve(data.user);

  dispatch({
    type: CREATE_USER_SUCCESS,
    payload: {
      user: data.user,
    },
  });
};

export const createUserFailure = reject => dispatch => {
  reject();

  dispatch({
    type: CREATE_USER_FAILURE,
  });
};

export const createUserRequest = () => ({
  type: CREATE_USER_REQUEST,
});

export const createUser = (token, data) => dispatch => {
  dispatch(createUserRequest());

  return new Promise((resolve, reject) => {
    fetchApi({
      path: '/users',
      method: 'post',
      token,
      body: JSON.stringify(data),
      dispatch,
      cb: createUserSuccess.bind(this, resolve),
      fb: createUserFailure.bind(this, reject),
    });
  });
};

/**
 * Reset password
 */
export const resetPasswordSuccess = (resolve, data) => dispatch => {
  resolve(data.user);

  dispatch({
    type: RESET_PASSWORD_SUCCESS,
  });
};

export const resetPasswordFailure = reject => dispatch => {
  reject();

  dispatch({
    type: RESET_PASSWORD_FAILURE,
  });
};

export const resetPasswordRequest = () => ({
  type: RESET_PASSWORD_REQUEST,
});

export const resetPassword = (token, userId) => dispatch => {
  dispatch(resetPasswordRequest());

  return new Promise((resolve, reject) => {
    fetchApi({
      path: `/users/${userId}/password`,
      method: 'get',
      token,
      dispatch,
      cb: resetPasswordSuccess.bind(this, resolve),
      fb: resetPasswordFailure.bind(this, reject),
    });
  });
};

/**
 * Fetch user
 */
export const fetchUserSuccess = data => ({
  type: FETCH_USER_SUCCESS,
  payload: {
    user: data.user,
  },
});

export const fetchUserFailure = () => ({
  type: FETCH_USER_FAILURE,
});

export const fetchUserRequest = () => ({
  type: FETCH_USER_REQUEST,
});

export const fetchUser = (token, userId) => dispatch => {
  dispatch(fetchUserRequest());

  return fetchApi({
    path: `/users/${userId}`,
    method: 'get',
    token,
    dispatch,
    cb: fetchUserSuccess,
    fb: fetchUserFailure,
  });
};

/**
 * Update user contact info
 */
export const updateUserContactInfoSuccess = (resolve, data) => dispatch => {
  resolve(data.user);

  dispatch({
    type: UPDATE_USER_SUCCESS,
    payload: {
      user: data.user,
    },
  });
};

export const updateUserContactInfoFailure = reject => dispatch => {
  reject();

  dispatch({
    type: UPDATE_USER_FAILURE,
  });
};

export const updateUserContactInfoRequest = () => ({
  type: UPDATE_USER_REQUEST,
});

export const updateUserContactInfo = (token, userId, data) => dispatch => {
  dispatch(updateUserContactInfoRequest());

  return new Promise((resolve, reject) => {
    fetchApi({
      path: `/users/${userId}/contact`,
      method: 'put',
      token,
      body: JSON.stringify(data),
      dispatch,
      cb: updateUserContactInfoSuccess.bind(this, resolve),
      fb: updateUserContactInfoFailure.bind(this, reject),
    });
  });
};



// WEBPACK FOOTER //
// ./src/actions/users.js